/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Initial_Credits_EnabledInputs */

const en_admin_settings_fields_initial_credits_enabled = /** @type {(inputs: Admin_Settings_Fields_Initial_Credits_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grant credits on signup`)
};

const zh_admin_settings_fields_initial_credits_enabled = /** @type {(inputs: Admin_Settings_Fields_Initial_Credits_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册赠送积分`)
};

/**
* | output |
* | --- |
* | "Grant credits on signup" |
*
* @param {Admin_Settings_Fields_Initial_Credits_EnabledInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_initial_credits_enabled = /** @type {((inputs?: Admin_Settings_Fields_Initial_Credits_EnabledInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Initial_Credits_EnabledInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_initial_credits_enabled(inputs)
	return zh_admin_settings_fields_initial_credits_enabled(inputs)
});
export { admin_settings_fields_initial_credits_enabled as "admin.settings.fields.initial_credits_enabled" }